import { KeyboardEvent, useEffect, useState } from 'react';

export const EditableLabel = ({
  value,
  onChange,
  className,
  isLoading
}: {
  value: string | null | undefined;
  onChange: (value: string) => void;
  className?: string;
  isLoading?: boolean;
}) => {
  const [editing, setEditing] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>(value ?? '');

  useEffect(() => {
    setInputValue(value ?? '');
    setEditing(false);
  }, [value]);

  const inputkeyPressed = (ev: KeyboardEvent<HTMLInputElement>) => {
    if (ev.key === 'Escape') {
      cancelInput();
    }

    if (ev.key === 'Enter' || ev.key === 'Tab') {
      onChange(inputValue);
      cancelInput();
    }
  };

  const cancelInput = () => {
    setEditing(false);
    setInputValue(value ?? '');
  };

  return editing ? (
    <input
      autoFocus
      className={['editable-label form-control', className].filter((p) => p).join(' ')}
      type='text'
      value={inputValue}
      onKeyUp={inputkeyPressed}
      onBlur={cancelInput}
      onChange={(ev) => setInputValue(ev.target.value)}
      disabled={isLoading}
    />
  ) : (
    <label
      className={['editable-label', isLoading ? 'text-muted' : null, className].filter((p) => p).join(' ')}
      onClick={() => setEditing(true)}
    >
      {value}
      <i className='align-self-center fa-pen fas' />
    </label>
  );
};
